import type {
  VideoConsultCreateRoomResponse,
  VideoConsultSendInvitationRequest,
  VideoConsultSendInvitationResponse,
} from '@quromedical/models';
import { trpcClient } from 'trpc';

export class VideoConsultApi {
  public async createRoom(
    patientId: string,
  ): Promise<VideoConsultCreateRoomResponse> {
    const result = await trpcClient.videoConsult.createMeetingRoom.mutate({
      subject: patientId,
    });

    return result;
  }

  public async sendInvite(
    body: VideoConsultSendInvitationRequest,
  ): Promise<VideoConsultSendInvitationResponse> {
    const result = await trpcClient.videoConsult.sendInvite.mutate(body);

    return result;
  }
}
